import { useRouteError } from "react-router-dom";
import React, { useEffect } from "react";
import { trackSentryException } from "./utils/helpers";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";

export default function ErrorPage() {
  const error: any = useRouteError();
  console.error(error);

  useEffect(() => {
    trackSentryException(error);
  }, []);

  return (
    <PageWrapper>
      <Typography variant="h3">Oops!</Typography>
      <Typography variant="h6">
        Sorry, an unexpected error has occurred.
      </Typography>
      <Typography className={"paragraph"}>
        <i>{error.statusText || error.message}</i>
      </Typography>
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  gap: 0.5rem;
`;
